import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';

const Header = () => {
  const {calcActualSize} = useScreenSize();
  return (
    <View style={[theme.flex.row, styles.container]}>
      <View style={[theme.flex.flex1, theme.flex.row]}>
        <View style={[{width: calcActualSize(64)}]}>
          <Text>ISSUE</Text>
        </View>
        <View style={[theme.flex.flex1, theme.flex.center]}>
          <Text>RESULT</Text>
        </View>
      </View>
      <View style={[theme.flex.flex1, theme.flex.row, theme.flex.between]}>
        <View style={{width: calcActualSize(30)}}>
          <Text textAlign="center">SUM</Text>
        </View>
        <Text>VALUE</Text>
        <View style={{width: calcActualSize(52)}}>
          <Text textAlign="right">NUMBER</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#E9ECF5',
    paddingHorizontal: 12,
    paddingVertical: 8,
    columnGap: 12,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    marginHorizontal: 12,
  },
});

export default Header;
